import { isJoinFlowPath } from '~/utils/joinRoutes'

export interface RouteLike {
  name?: unknown
  path: string
}

/**
 * Whether the global route-loading overlay (CustomLoading) should cover a navigation.
 *
 * - Query-only navigations (pagination, sort, filters) are not covered: Nuxt2 never
 *   covered them.
 * - Step-to-step navigation inside the join flow is not covered: join steps hold the
 *   previous step on screen until the next has its data, and JoinLayout shows a top
 *   progress bar instead. AB#64268
 */
export const shouldCoverNavigation = (to: RouteLike, from: RouteLike): boolean => {
  if (to.name === from.name && to.path === from.path) return false
  if (isJoinFlowPath(to.path) && isJoinFlowPath(from.path)) return false
  return true
}
